import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  dropdownLookup,
  submitForm,
  submitFormReg,
  getPrepop,
  submitCaptcha,
  requestCaptcha,
  sendCommunications,
  taxRegistration,
} from "./API";
import { IDType } from "@soqs/common";
import { PAGES } from "../App";
export const getDropdownData = createAsyncThunk(
  "trn/getDropdownData",
  async (_, {  rejectWithValue, fulfillWithValue }) => {
    return dropdownLookup()
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const submitFormAsync = createAsyncThunk(
  "trn/submit",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return submitForm(getState().trn.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const submitFormRegAsync = createAsyncThunk(
  "trn/submitReg",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return submitFormReg(getState().trn.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const refreshCaptchaAsync = createAsyncThunk(
  "trn/refreshCaptcha",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    return requestCaptcha()
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);
export const submitCaptchaAsync = createAsyncThunk(
  "trn/submitCaptcha",
  async (captcha, {  rejectWithValue, fulfillWithValue }) => {
    return submitCaptcha(captcha)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);
export const getPrepopDataAsync = createAsyncThunk(
  "trn/prepop",
  async (token, {  rejectWithValue, fulfillWithValue }) => {
    return getPrepop(token)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const taxRegistrationAsync = createAsyncThunk(
  "trn/taxRegistration",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return taxRegistration(getState().trn.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const sendCommunicationAsync = createAsyncThunk(
  "trn/sendCommunications",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return sendCommunications(getState().trn.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const trnAppSlice = createSlice({
  name: "trn",
  initialState: {
    loading: false,
    errors: null,
    page: 0,
    dropdownsloading: false,
    dropdownoptions: [],
    returnedSearchResultsTRN: null,
    prepopData: false,
    captchaAudio: null,
    captchaImage: null,
    confirmMessage: null,
    confirmTitle: null,
    useEmailAddress: true,
    useMobileNumber: true,
    isKiosk: false,
    isSOQS: false,
    isScanner: false,
    endMessage: false,
    IDType: IDType.RSA_Id,
  },
  reducers: {
    updateFormState: (state, action) => {
      state.formState = action.payload;
    },
    clearErrors: (state) => {
      state.errors = null;
    },
    cancelVerification: (state, action) => {
      state.loading = false;
      state.errors = null;
      state.page = action.payload?.targetPage ?? 0;
      if (!state.isKiosk && !state.isSOQS) {
        state.formState = null;
      }
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageNext: (state, action) => {
      state.formState = action.payload;
      state.page += 1;
    },
    setPageReg: (state, action) => {
      state.formState = action.payload;
      state.page = 1;
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setConfirmMessage: (state, action) => {
      state.confirmMessage = action.payload.confirmmessage;
      state.confirmTitle = action.payload.confirmtitle;
    },
  },
  extraReducers: (builder) => {
    builder
      //Submit Form Promise cases
      .addCase(submitFormAsync.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(submitFormAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = null;
        // state.formState = action.payload;
        if (action.payload.captchaImage) {
          state.captchaImage = action.payload.captchaImage;
          state.captchaAudio = action.payload.captchaAudio;
          state.page = PAGES.Captcha;
        } else {
          state.returnedSearchResultsTRN = action.payload;
          state.page = PAGES.TRNSearchResultsForm;
        }
      })
      .addCase(submitFormAsync.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = action.payload;
      })

      .addCase(submitFormRegAsync.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(submitFormRegAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = null;

        if (action.payload.captchaImage) {
          state.captchaImage = action.payload.captchaImage;
          state.captchaAudio = action.payload.captchaAudio;
          state.page = PAGES.Captcha;
        } else {
          state.formState = action.payload;
          state.confirmMessage = action.payload.confirmmessage;
          state.confirmTitle = action.payload.confirmtitle;
          state.endMessage = action.payload.endMessage;
          state.page = PAGES.Confirmation;
        }
      })
      .addCase(submitFormRegAsync.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(getDropdownData.pending, (state) => {
        state.dropdownsloading = true;
      })
      .addCase(getDropdownData.fulfilled, (state, action) => {
        state.dropdownsloading = false;
        state.dropdownoptions = action.payload;
      })
      .addCase(getDropdownData.rejected, (state, action) => {
        state.dropdownsloading = false;
        state.errors = action.payload;
      })
      //Get Prepop
      .addCase(getPrepopDataAsync.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(getPrepopDataAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = null;
        if (action.payload) {
          state.prepopData = action.payload.prepopData;
          state.isSOQS = action.payload.channel === "SOQS" ? true : false;
          state.isKiosk = action.payload.channel === "Kiosk" ? true : false;
          state.skipCaptcha = action.payload.skipCaptcha === "true" ? true : false;
          state.formState = { values: action.payload.prepopData };
        }
      })
      .addCase(getPrepopDataAsync.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = action.payload;
        state.notice = null;
        state.message = null;
      })
      .addCase(submitCaptchaAsync.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.confirmtitle) {
          state.formState = action.payload;
          state.confirmMessage = action.payload.confirmmessage;
          state.confirmTitle = action.payload.confirmtitle;
          state.endMessage = action.payload.endMessage;
          state.page = PAGES.Confirmation;
        } else {
          state.returnedSearchResultsTRN = action.payload;
          state.page = PAGES.TRNSearchResultsForm;
        }
      })
      .addCase(submitCaptchaAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(submitCaptchaAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshCaptchaAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.captchaImage = action.payload.captchaImage;
        state.captchaAudio = action.payload.captchaAudio;
      })
      .addCase(refreshCaptchaAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(refreshCaptchaAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendCommunicationAsync.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(sendCommunicationAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = null;
        //state.returnedSearchResultsTRN = action.payload;
        state.formState = action.payload;
        state.confirmMessage = action.payload.confirmmessage;
        state.confirmTitle = action.payload.confirmtitle;
        state.page = PAGES.Confirmation;
      })
      .addCase(sendCommunicationAsync.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = action.payload;
        state.otpMethods = null;
      });
  },
});

export const {
  updateFormState,
  clearErrors,
  cancelVerification,
  setErrors,
  setPage,
  setPageNext,
  setPageReg,
  setConfirmMessage,
} = trnAppSlice.actions;

export const isLoading = (state) => state?.trn?.loading;
export const isPrepop = (state) => state?.trn?.prepopData;
export const formState = (state) => state?.trn?.formState;
export const errors = (state) => state?.trn?.errors;
export const currentPage = (state) => state?.trn?.page;
export const dropdownoptions = (state) => state?.trn?.dropdownoptions;
export const dropdownsloading = (state) => state?.trn?.dropdownsloading;
export const captchaAudio = (state) => state?.trn?.captchaAudio;
export const captchaImage = (state) => state?.trn?.captchaImage;
export const confirmMessage = (state) => state?.trn?.confirmMessage;
export const confirmTitle = (state) => state?.trn?.confirmTitle;
export const searchResultsTRN = (state) => state?.trn?.returnedSearchResultsTRN;
export const useEmailAddress = (state) => state?.trn?.useEmailAddress;
export const useMobileNumber = (state) => state?.trn?.useMobileNumber;
export const isKiosk = (state) => state?.trn?.isKiosk;
export const skipCaptcha = (state) => state?.trn?.skipCaptcha;
export const isSOQS = (state) => state?.trn?.isSOQS;
export const isScanner = (state) => state?.trn?.scanner;
export const endMessage = (state) => state?.trn?.endMessage;

export default trnAppSlice.reducer;
